import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { getBoylikegirlClubProgram } from "../apis/services/steemActivity";
import { uploadImage } from "../unit/UploadImage";
import { extractLoginData, getAccount } from "../unit/UserUtil";
import dsteem from "../unit/DsteemUtil";
import { extractImage } from "../unit/Tools";
import { ElMessage, ElLoading } from "element-plus";
import PostAdvancedSettings from "../components/PostAdvancedSettings.vue";
import { sapEdit } from "../unit/boylikegirlcluboperUtil";
import { $t } from "../plugins/i18n";
import { dateAddDay, formatDate, countChars, countChineseChars } from "../unit/public";
export default {
  components: {
    PostAdvancedSettings: PostAdvancedSettings
  },
  data: function data() {
    return {
      beneficiarieList: [],
      //dynamicTags: ["hive-166109"],
      dynamicTags: ["boylikegirlclub", "steemexclusive"],
      inputVisible: false,
      inputValue: "",
      language: localStorage.getItem("locale") == "zh" ? "zh-CN" : "en",
      postBody: localStorage.getItem(this.sap + "postBodyDraft") == null ? "" : localStorage.getItem(this.sap + "postBodyDraft"),
      postTitle: localStorage.getItem(this.sap + "postTitleDraft") == null ? "" : localStorage.getItem(this.sap + "postTitleDraft"),
      timeSpan: localStorage.getItem(this.sap + "timeSpan") == null ? 0 : localStorage.getItem(this.sap + "timeSpan"),
      postTime: "",
      loginData: null,
      imageList: [],
      loadingInstance: null,
      postLoad: false,
      subfield: true,
      defaultOpen: "",
      dialogVisible: false,
      uploadPercentage: 0,
      xssOptions: {
        whiteList: {
          center: ["href", "title", "target"]
        }
      },
      toolbars: {
        bold: true,
        // 粗体
        italic: true,
        // 斜体
        header: true,
        // 标题
        underline: true,
        // 下划线
        strikethrough: true,
        // 中划线
        mark: true,
        // 标记
        superscript: true,
        // 上角标
        subscript: true,
        // 下角标
        quote: true,
        // 引用
        ol: true,
        // 有序列表
        ul: true,
        // 无序列表
        link: true,
        // 链接
        imagelink: true,
        // 图片链接
        code: true,
        // code
        table: true,
        // 表格
        fullscreen: true,
        // 全屏编辑
        readmodel: true,
        // 沉浸式阅读
        htmlcode: true,
        // 展示html源码
        help: true,
        // 帮助

        /* 1.3.5 */
        undo: true,
        // 上一步
        redo: true,
        // 下一步
        trash: true,
        // 清空
        save: true,
        // 保存（触发events中的save事件）

        /* 1.4.2 */
        navigation: true,
        // 导航目录

        /* 2.1.8 */
        alignleft: false,
        // 左对齐
        aligncenter: true,
        // 居中
        alignright: false,
        // 右对齐

        /* 2.2.1 */
        subfield: true,
        // 单双栏模式
        preview: true // 预览

      },
      isEdit: false,
      currentPermlink: "",
      isShowModelAdvancedSetting: false,
      sap: "",
      isHavePermission: false,
      isLoaded: false,
      enChartNum: 0,
      cnChartNum: 0
    };
  },
  watch: {
    postTitle: function postTitle(newVal) {
      localStorage.setItem(this.sap + "postTitleDraft", newVal);
    }
  },
  methods: {
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.inputVisible = true;
      this.$nextTick(function () {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;

      if (inputValue) {
        this.dynamicTags.push(inputValue.replace(".", ""));
      }

      this.inputVisible = false;
      this.inputValue = "";
    },
    uploadImageCallback: function uploadImageCallback(res) {
      this.uploadPercentage = Math.floor(res.loaded / res.total * 100);
    },
    imgAdd: function imgAdd(pos, $file) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogVisible = true;
                _context.next = 3;
                return uploadImage($file, _this2.uploadImageCallback);

              case 3:
                url = _context.sent;

                _this2.$refs.md.$img2Url(pos, url);

                _this2.dialogVisible = false;
                _this2.uploadPercentage = 0;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    saveDraft: function saveDraft(value) {
      localStorage.setItem(this.sap + "postBodyDraft", value);
      this.enChartNum = countChars(value);
      this.cnChartNum = countChineseChars(value);
    },
    publish: function publish() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var input, json_metadata, that, beneficiaries, postResult, timeoutId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.imageList = extractImage(_this3.postBody);
                _this3.dynamicTags;

                if (_this3.dynamicTags[0] == "boylikegirlclub") {
                  _this3.dynamicTags[0] = "hive-150487";
                }

                _this3.postLoad = true;

                if (!_this3.loginData) {
                  _context2.next = 31;
                  break;
                }

                input = new Object();
                input.postingKey = _this3.loginData[1];
                input.author = _this3.loginData[0];
                input.body = _this3.postBody;
                input.taglist = _this3.dynamicTags;
                input.title = _this3.postTitle;
                json_metadata = new Object();
                json_metadata.app = "boylikegirl.club/0.1";
                json_metadata.format = "markdown+html";
                json_metadata.image = _this3.imageList;
                json_metadata.tags = input.taglist;
                input.json_metadata = JSON.stringify(json_metadata);
                that = _this3;
                beneficiaries = [];

                _this3.beneficiarieList.forEach(function (value) {
                  beneficiaries.push({
                    account: value.useranme,
                    weight: value.percentage * 100
                  });
                });

                _context2.prev = 20;
                _context2.next = 23;
                return dsteem.postBlogWithOptions(input, _this3.isEdit, _this3.currentPermlink, beneficiaries);

              case 23:
                postResult = _context2.sent;

                if (postResult.id) {
                  ElMessage({
                    message: _this3.$t("success.postSuccess"),
                    type: "success",
                    duration: 5000
                  });
                  localStorage.setItem(_this3.sap + "postBodyDraft", "");
                  localStorage.getItem(_this3.sap + "postTitleDraft", "");
                  localStorage.setItem(_this3.sap + "postTag", JSON.stringify(_this3.dynamicTags));
                  timeoutId = setTimeout(function () {
                    clearTimeout(timeoutId);

                    _this3.$router.push({
                      path: (input.taglist[0] ? "/" + input.taglist[0] : "") + "/@" + input.author + "/" + input.permlink
                    });

                    _this3.postLoad = false;
                    _this3.postBody = "";
                    _this3.postTitle = "";
                  }, 5000);
                }

                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2["catch"](20);
                ElMessage.error(_context2.t0);
                _this3.postLoad = false;

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[20, 27]]);
      }))();
    },
    sapSubmit: function sapSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var input, json_metadata, beneficiaries, postResult, timeoutId;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.imageList = extractImage(_this4.postBody);
                _this4.dynamicTags;

                if (_this4.dynamicTags[0] == "boylikegirlclub") {
                  _this4.dynamicTags[0] = "hive-150487";
                }

                _this4.postLoad = true;

                if (_this4.postTime) {
                  _context3.next = 8;
                  break;
                }

                ElMessage.error(_this4.$t("error.sapDatetimeNotNull"));
                _this4.postLoad = false;
                return _context3.abrupt("return");

              case 8:
                if (!_this4.loginData) {
                  _context3.next = 35;
                  break;
                }

                input = new Object();
                input.author = _this4.loginData[0];
                input.planPostTime = _this4.postTime;
                input.taglist = _this4.dynamicTags;
                input.body = _this4.postBody;
                input.title = _this4.postTitle;
                input.id = _this4.$route.params.id ? _this4.$route.params.id : 0;
                json_metadata = new Object();
                json_metadata.app = "boylikegirl.club/0.1";
                json_metadata.format = "markdown+html";
                json_metadata.image = _this4.imageList;
                json_metadata.tags = input.taglist;
                input.json_metadata = JSON.stringify(json_metadata);
                beneficiaries = [];

                if (_this4.beneficiarieList) {
                  _this4.beneficiarieList.forEach(function (value) {
                    beneficiaries.push({
                      account: value.useranme,
                      weight: value.percentage * 100
                    });
                  });

                  input.beneficiaries = JSON.stringify(beneficiaries);
                }

                _context3.prev = 24;
                _context3.next = 27;
                return sapEdit(input);

              case 27:
                postResult = _context3.sent;

                if (postResult.code == 0) {
                  ElMessage({
                    message: _this4.$t("success.postSuccess"),
                    type: "success",
                    duration: 5000
                  });
                  localStorage.setItem(_this4.sap + "postBodyDraft", "");
                  localStorage.setItem(_this4.sap + "postTitleDraft", "");
                  localStorage.setItem(_this4.sap + "postTag", JSON.stringify(_this4.dynamicTags));
                  localStorage.setItem(_this4.sap + "timeSpan", _this4.timeSpan);
                  localStorage.setItem(_this4.sap + "postTime", _this4.postTime);
                  timeoutId = setTimeout(function () {
                    clearTimeout(timeoutId);

                    _this4.$router.push({
                      path: "/sap/" + _this4.$route.params.programId
                    });

                    _this4.postLoad = false;
                    _this4.postBody = "";
                    _this4.postTitle = "";
                  }, 5000);
                }

                _context3.next = 35;
                break;

              case 31:
                _context3.prev = 31;
                _context3.t0 = _context3["catch"](24);
                ElMessage.error(_context3.t0);
                _this4.postLoad = false;

              case 35:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[24, 31]]);
      }))();
    },
    getComment: function getComment() {
      var comments = [];
      var that = this;
      dsteem.getState(this.$route.params.community + "/@" + this.$route.params.username + "/" + this.$route.params.permlink).then(function (result) {
        var content = result.content[that.$route.params.username + "/" + that.$route.params.permlink];
        that.postBody = content.body;
        that.postBody = that.postBody.replace("<br /><br /><br /> <p><em>(Published through Steemit Dapp https://boylikegirl.club)</em></p>", "");
        that.postTitle = content.title;
        that.dynamicTags = JSON.parse(content.json_metadata).tags;
      });
    },
    saveAdvancedSettings: function saveAdvancedSettings() {
      localStorage.setItem(this.sap + "beneficiarieList", JSON.stringify(this.beneficiarieList));
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var account, checkAuth, arrayindex, i, len, beneficiarie;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (document.body.clientWidth < 1200) {
                _this5.subfield = false;
                _this5.defaultOpen = "edit";
              } else {
                _this5.subfield = true;
              }

              _this5.loginData = extractLoginData();
              _context4.next = 4;
              return getAccount(_this5.loginData[0]);

            case 4:
              account = _context4.sent;

              if (!(_this5.$route.name.indexOf("sappost") >= 0)) {
                _context4.next = 28;
                break;
              }

              _context4.next = 8;
              return getBoylikegirlClubProgram(_this5.$route.params.programId);

            case 8:
              _this5.program = _context4.sent.data;
              _this5.sap = "sappost";

              if (!_this5.loginData) {
                _context4.next = 28;
                break;
              }

              _this5.currentUserName = _this5.loginData[0];
              _this5.isUseKeychain = _this5.loginData[4] == "true";
              checkAuth = account.posting.account_auths;
              arrayindex = -1;

              if (!(_this5.currentUserName == _this5.program.username)) {
                _context4.next = 19;
                break;
              }

              _this5.isHavePermission = true;
              _context4.next = 28;
              break;

            case 19:
              i = 0, len = checkAuth.length;

            case 20:
              if (!(i < len)) {
                _context4.next = 28;
                break;
              }

              if (!(checkAuth[i][0] == _this5.program.username)) {
                _context4.next = 25;
                break;
              }

              arrayindex = i;
              _this5.isHavePermission = true;
              return _context4.abrupt("break", 28);

            case 25:
              i++;
              _context4.next = 20;
              break;

            case 28:
              if (localStorage.getItem(_this5.sap + "postTag") && localStorage.getItem(_this5.sap + "postTag") != "undefined") {
                _this5.dynamicTags = JSON.parse(localStorage.getItem(_this5.sap + "postTag"));
              }

              if (localStorage.getItem(_this5.sap + "timeSpan") && localStorage.getItem(_this5.sap + "timeSpan") != "undefined") {
                _this5.timeSpan = localStorage.getItem(_this5.sap + "timeSpan");
              }

              if (localStorage.getItem(_this5.sap + "postTime") && localStorage.getItem(_this5.sap + "postTime") != "undefined" && _this5.timeSpan != 0) {
                _this5.postTime = formatDate(dateAddDay(localStorage.getItem(_this5.sap + "postTime"), _this5.timeSpan), "yyyy-MM-dd hh:mm:ss"); //console.log(this.postTime);
              }

              if (_this5.$route.params.community) {
                _this5.dynamicTags[0] = _this5.$route.params.community;
              }

              _this5.postBody = localStorage.getItem(_this5.sap + "postBodyDraft") == null ? "" : localStorage.getItem(_this5.sap + "postBodyDraft");
              _this5.postTitle = localStorage.getItem(_this5.sap + "postTitleDraft") == null ? "" : localStorage.getItem(_this5.sap + "postTitleDraft");
              if (!_this5.postBody.includes(account.signature) && account.signature) _this5.postBody += account.signature;

              if (!_this5.loginData) {
                _this5.$router.push({
                  path: "/"
                });
              }

              if (_this5.$route.params.permlink && _this5.$route.params.username) {
                if (_this5.loginData[0] != _this5.$route.params.username) {
                  _this5.$router.push({
                    path: "/"
                  });
                } else {
                  _this5.isEdit = true;
                  _this5.currentPermlink = _this5.$route.params.permlink;

                  _this5.getComment();
                }
              }

              if (localStorage.getItem(_this5.sap + "beneficiarieList") && localStorage.getItem(_this5.sap + "beneficiarieList") != "undefined") {
                _this5.beneficiarieList = JSON.parse(localStorage.getItem(_this5.sap + "beneficiarieList"));
              } else {
                beneficiarie = {
                  id: 0,
                  percentage: 100,
                  useranme: _this5.loginData[0]
                };

                _this5.beneficiarieList.push(beneficiarie);
              }

              _this5.isLoaded = true;

            case 39:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};